import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.js';
import { themeVars } from '@synoptic/ui-kit/theme/vars.js';
import { borderRadius, boxShadows, space } from '@synoptic/ui-kit/tokens.js';
import { typography } from '@synoptic/ui-kit/typography.js';
import { style } from '@vanilla-extract/css';

export const carouselItemHalfWidth = style({
  flex: '0 0 50%',
  minWidth: 'min(100%, 355px)',
  maxWidth: 'calc(50% - 10px)',
});

export const carouselItemFullWidth = style({
  flex: '0 0 100%',
  minWidth: 'min(100%, 320px)',
});

export const carouselItemThirdWidth = style({
  flex: '0 0 33.33%',
  minWidth: 'min(100%, 300px)',
  maxWidth: 'calc(33.33% - 10px)',
});

export const carouselItemQuarterWidth = style({
  flex: '0 0 25%',
  minWidth: 'min(100%, 245px)',
  maxWidth: 'calc(25% - 10px)',
});

export const homeExploreSection = style([
  {
    display: 'flex',
    flexDirection: 'column',
    gap: space.s24,
  },
  responsiveStyle({
    tablet: {
      outline: `1px solid ${themeVars.container.border.default}`,
      backgroundColor: themeVars.container.primary.background.idle,
      boxShadow: boxShadows.default,
      borderRadius: borderRadius.r16,
      padding: space.s24,
    },
  }),
]);

export const carouselButton = style({
  selectors: {
    '&:disabled': {
      backgroundColor: 'transparent',
    },
  },
});

export const carouselLeftButton = style({
  transform: 'rotate(180deg)',
});

export const sectionLabel = style({
  ...typography.titleMd,
});

export const sectionHeader = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: space.s30,
  marginBottom: space.s12,
});

export const sectionHeaderContent = style({
  display: 'flex',
  alignItems: 'center',
  gap: space.s8,
});

export const sectionNavigation = style({
  display: 'flex',
  alignItems: 'center',
  gap: space.s16,
});

export const sectionShowAllLink = style({
  ...typography.labelMd,
  textDecoration: 'underline',
  textWrap: 'nowrap',
});
